export const SGA_SPEND_CONTEXT_KIND_BY_LEVER = {
  professional_fees: 'decision_agent:professional_fees:governed_snapshot',
  outside_contractors: 'decision_agent:outside_contractors:governed_snapshot',
  indirect_procurement: 'decision_agent:indirect_procurement:governed_snapshot',
  travel_and_expense: 'decision_agent:travel_expense:governed_snapshot',
  shared_services: 'decision_agent:shared_services:governed_snapshot',
  tech_software: 'decision_agent:tech_software:governed_snapshot',
  real_estate_footprint: 'decision_agent:real_estate_footprint:governed_snapshot',
  marketing_spend: 'decision_agent:marketing_spend:governed_snapshot',
} as const;

export const SGA_SPEND_CONTEXT_KINDS = {
  financeLineReconciliation: 'decision_agent:finance:sga_line_reconciliation',
  costPoolMapping: 'decision_agent:sga_spend:cost_pool_mapping',
  industryReference: 'decision_agent:sga_spend:industry_reference',
  ownerMap: 'decision_agent:sga_spend:owner_map',
  controlPlan: 'decision_agent:sga_spend:control_plan',
  governedFloor: 'decision_agent:sga_spend:q04_governed_floor',
} as const;

export type SgaSpendContextKind =
  (typeof SGA_SPEND_CONTEXT_KIND_BY_LEVER)[keyof typeof SGA_SPEND_CONTEXT_KIND_BY_LEVER];
